import { Response } from '@ciaopeople/cp-shatsu/HTTP';
import { isFunction } from "@ciaopeople/cp-shatsu/TypeChecking";
import { ThirdParyClientAuthDataForSignIn } from "../login/data/LoginData.js";
import { isRESTAPIEvents, RESTAPIEvents } from "./RESTAPIEvents.js";
import { isRESTUserServices, RESTUserServices } from "./RESTUserServices.js";
import { DataDeletionInfo } from "./types/AuthDataTypes.js";
import { GroupedResolvedTopicObjs, GroupedTopicObjs } from "./types/NotificationDataTypes.js";
import { Ask1stPartyEmailAuthData, GrantStatusResponseContent, OnLoginResponse, UserGender } from "./types/UserDataTypes.js";
import { MembershipType } from '@api-commons/membership/MembershipController.js';
import { MembershipCardData} from "../membership/MembershipCardData.js";
import { BuyMembershipOptions, MembershipUpsellOptions } from '../sdk/ClientSdkPublicInterface.js';


export interface MembershipDetails {
    isMember: boolean;
    hasMembershipBillingItems: boolean;
    hasMemershipAccess: boolean;
}


export enum Ask1stPartyEmailLoginOperation {

    SIGN_IN = "signin",
    SIGN_UP = "signup",
    VERIFICATION = "verification",
    IDENTITY_CONFIRMATION = "identity_confirmation"
}


export interface APIClientInterface extends RESTUserServices, RESTAPIEvents {
    
    updateToken(tok: string): Promise<boolean>
    testGrant(token: string): Promise<Response<GrantStatusResponseContent>>;
    signIn(appToken: string, tpud: ThirdParyClientAuthDataForSignIn): Promise< Response<OnLoginResponse>>;
    flushToken(): Promise<boolean>
    deletePersonalData(checkField: string): Promise<Response<DataDeletionInfo>>
    resolveFollowedTopics(topics: GroupedTopicObjs): Promise<Response<GroupedResolvedTopicObjs>>;

    getMembershipBuyLink(): Promise<string>
    getMembershipGiftLink(): Promise<string>
    getRedeemGiftLink(subscriptionId: string, userId: string, checkId: string): Promise<string>
    getMembershipManagementLink(sub: string): Promise<string>;
    getDirectBuyLink(prod: MembershipType, options: BuyMembershipOptions): Promise<string>;
    getOrderPaymentLink(order: string, key: string): Promise<string>;

    getMembershipDetails():Promise<MembershipDetails>;
    hasMembershipAccess():Promise<boolean>;
    getMembershipCardData():Promise<MembershipCardData>;
    setMembershipCardData(firstName: string, lastName: string):Promise<Response<OnLoginResponse>>;
    generateMembershipCard():Promise<Response<void>>;

    getMembershipSwitchLink(redirectUrl?: string): Promise<string>;
    getMembershipUpsellLink(options?: MembershipUpsellOptions): Promise<string>;
}


export function isAPIClientInterface(ele: any): ele is APIClientInterface {
    return isRESTUserServices(ele) && isRESTAPIEvents(ele) && 
            isFunction(ele['updateToken']) && 
            isFunction(ele['testGrant']) && 
            isFunction(ele['signIn']) && 
            isFunction(ele['flushToken']) && 
            isFunction(ele['deletePersonalData']) && 
            isFunction(ele['resolveFollowedTopics']) && 
            isFunction(ele['getMembershipBuyLink']) &&
            isFunction(ele['getMembershipGiftLink']) && 
            isFunction(ele['getRedeemGiftLink']) &&
            isFunction(ele['getMembershipManagementLink']) &&
            isFunction(ele['getDirectBuyLink']) &&
            isFunction(ele['hasMembershipAccess']) &&
            isFunction(ele['getMembershipCardData']) &&
            isFunction(ele['setMembershipCardData']) &&
            isFunction(ele['generateMembershipCard']) &&
            isFunction(ele['getMembershipSwitchLink']) &&
            isFunction(ele['getMembershipUpsellLink']);           
            
}